import { SelectBox } from "@monolith-forensics/monolith-ui";
import { FC, useState } from "react";

interface ObserverSelectorProps {
  defaultValue?: 0 | 1;
  value?: 0 | 1;
  onChange?: (value: any, data: any) => void;
  error?: string;
  disabled?: boolean;
}

const writeAccessOptions = [
  {
    label: "Write Access",
    value: 0,
  },
  {
    label: "Read Only",
    value: 1,
  },
];

const ObserverSelector: FC<ObserverSelectorProps> = ({
  defaultValue,
  value,
  onChange,
  error,
  disabled = false,
}) => {
  const isControlled = value !== undefined;

  const [stateValue, setStateValue] = useState<number | undefined>(
    defaultValue
  );

  const _value = isControlled ? value : stateValue;

  const handleChange = (value: any, data: any) => {
    if (!isControlled) {
      setStateValue(value);
    }
    onChange?.(value, data);
  };

  return (
    <SelectBox
      data={writeAccessOptions}
      value={_value}
      onChange={handleChange}
      error={error}
      size="sm"
      variant="outlined"
      label="Observer Status"
      required={true}
      disabled={disabled}
    />
  );
};

export default ObserverSelector;
